module.exports = __webpack_public_path__ + "static/media/CompleteButton.3c392b2a.svg";